import arrow_back_ios_new from "../../assets/Images/arrow_back_ios_new.png";


import "../../assets/css/style.css";
import { useNavigate } from "react-router-dom";
import { useState, useContext, useEffect } from "react";


import { useAsaSession,  useAsaSessionPagesMutation, useBackButton } from '../../services/AsaSessionServices'

import { useActiveSubscriptions, useSubscriptionsPlans, useFintechLayouts,useSubscriptionStatus } from '../../services/AsaApiServices'
import { IAsaSession, Plan, SessionPage,SubscriptionDetail } from "../../types/types";

import LoaderComponent from "../../components/LoaderComponent";

import { useTranslation } from "react-i18next";

import TransferPlanItem , { PlanAction }  from "./TransferPlanItem";
import TransferManagePlan from "./TransferManagePlan";
import  asatransfersvg from "../../assets/Images/asatransfer.svg";
import App from "../../../App";
import { AsaStateContext } from "../../components/AsaStateProvider";
import { AnalyticsService, AnalyticsAction, AnalyticsFeature } from "../../services/AnalyticsService";
  


export default function AsaTransferLanding() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const {data: subscriptionStatus}=useSubscriptionStatus()
  const { data: session } = useAsaSession()
  const { data: subscriptions } = useActiveSubscriptions()
  const { data: subscriptionsPlans } = useSubscriptionsPlans()
  const sessionMutation = useAsaSessionPagesMutation()

  const [state, ] = useContext(AsaStateContext)
  const layout = useFintechLayouts()
  const [isShowBackButton, _] = useState(true);

  const [isContinueMode, setIsContinueMode] = useState(false);

  useEffect(() => {
    AnalyticsService.track("ASATransfer Landing Viewed", AnalyticsAction.View, AnalyticsFeature.AsaTransfer, {
      subscriptionName: activeSubscription?.subscriptionTitle,
      price: activeSubscription?.billingAmount,
    });
  }, []);
 
  const [selectedPlan, setSelectedPlan] = useState<Plan | null>(null);
  const genericBackClick = useBackButton()

  const activeSubscription= subscriptions?.findLast(x=>x.subscriptionStatus="Active") as SubscriptionDetail;

  

  const handleBackClick=() => {
    if(!isContinueMode)
    {
      genericBackClick();
      return;
    }
    setIsContinueMode(false);
  }
  const onPlanSelect = (plan: Plan) => {
    AnalyticsService.track("ASATransfer Plan Selected", AnalyticsAction.Click, AnalyticsFeature.AsaTransfer, {
      subscriptionName: plan?.subscriptionTitle,
      price: plan?.recurringAmount,
    });
    if(!!!activeSubscription){
      handleProceed(plan)
    }else{
      setSelectedPlan(plan)
    }
  }
  const handleProceed = async (
    plan: Plan | null,
  ) => {
    
    const planToProceeed = plan ?? subscriptionsPlans?.find(x=>x.subscriptionPlanCode===activeSubscription?.subscriptionPlanCode)


    const sessionToUpdate: IAsaSession = { ...session } as IAsaSession
    sessionToUpdate.sessionPages = undefined
    const sessionpages = [] as SessionPage[]
    sessionpages.push({
      pageNumber: 2,
      pageName: "GOALS PLANS",
      pageTitle: "Select Package",
      pageDescription: "Select Package",
      pageUrl: "/asatransfer",
      pageStatusMessage: "INCOMPLETE",
      pageData: JSON.stringify(planToProceeed)
    } as SessionPage)
    sessionpages.push({
      pageNumber: 81,
      pageName: 'Landingyes',
      pageTitle: 'Landingyes',
      pageDescription: 'Landingyes',
      pageUrl: '/asatransfer',
     // pageData: JSON.stringify({ Landing: "true",SkipUpgradeMode: true }),
     pageData: JSON.stringify({ Landing: "true"}),
    } as SessionPage
    )

   
    try {

      const response = await sessionMutation.mutateAsync({ asaSession: sessionToUpdate, extraPages: sessionpages })
      AnalyticsService.track("ASATransfer Proceed Success", AnalyticsAction.API_Result, AnalyticsFeature.AsaTransfer, {
        subscriptionName: planToProceeed?.subscriptionTitle,
        price: planToProceeed?.recurringAmount,
      });
      navigate("/subscriptionpayment");
    } catch (error) {
      AnalyticsService.track("ASATransfer Proceed Error", AnalyticsAction.API_Result, AnalyticsFeature.AsaTransfer, {
        subscriptionName: planToProceeed?.subscriptionTitle,
        price: planToProceeed?.recurringAmount,
      });
      console.error("Error updating session:", error);

    }
  };

  


  return (
    <div className=" flex justify-center items-center  h-screen">
      <LoaderComponent />
      <div className="w-full h-full flex flex-col  text-white relative z-20"
        style={layout?.backGroundStyle}>
         
        <div className="flex items-center  p-4 mt-2 h-[72px] z-50">
        
        { isShowBackButton && 
          <>
            <img
              alt="back"
              className="flex cursor-pointer p-2 shadow-2xl rounded-lg w-10 h-10"
              src={arrow_back_ios_new}
              onClick={handleBackClick}
            />
            <span className="flex text-white font-poppins text-base font-semibold leading-normal"
              onClick={handleBackClick}
            >
              {t("return")}
            </span>
          </>
      }
        </div>
          
        <div
          className="flex-grow relative rounded-t-3xl mt-6 p-6 flex flex-col bg-[#EBECF0] dark:bg-[#121212]"
          
        >
       
          <div className="flex justify-center items-center -mt-20">
            <div className="w-[84px] h-[84px] rounded-md   overflow-hidden "
            style={state.isDarkMode?{}: { filter: 'drop-shadow(0 4px 6px rgba(100, 100, 100, 0.8))' }}
            >
                <img
                  alt="AsaTransfer"
                  src={layout?.appIcon}
                  width={85}
                  height={85}

                />
            </div>
          </div>
          <div className="flex flex-grow flex-col  mt-2 ">
            <div className="flex flex-col mb-6 items-center">
              <span className=" dark:text-white text-[#4E4E4E] text-center font-poppins text-lg font-semibold leading-5 tracking-[-0.1px]">
               {layout?.appName ?? "ASA Transfer"}
              
            </span>
            </div>
            <div className="flex flex-col flex-1 min-h-0" >
              <div className="inline-flex flex-col justify-center items-start gap-4 p-5 px-[25px] py-5 rounded-lg bg-[#D9D9D9] dark:bg-[#282828]">
                {!!activeSubscription && 
                  <div className="flex flex-col">
                    <span className="dark:text-white text-[#4E4E4E] font-poppins text-lg font-bold leading-5 tracking-[-0.1px]">
                    {subscriptionStatus?.availableTransferMessage} 
                    </span>
                  </div>
                }
                {!!!activeSubscription && isContinueMode &&
                  <div className="flex flex-col">
                    <span className="dark:text-white text-[#4E4E4E] font-poppins text-lg font-bold leading-5 tracking-[-0.1px]">
                    {t("subscriptionOptions")} 
                    </span>
                  </div>
                }
                <div className="flex flex-col">
                  <span className="dark:text-[#D8D8D8]  text-[#4E4E4E] font-poppins text-sm font-normal leading-5 tracking-[-0.1px]">
                  {t("transferdescription")} 
                  </span>
                </div>
             
              {isContinueMode && (
                subscriptionsPlans?.map((plan, index) => (
                 <TransferPlanItem
                   key={plan?.subscriptionPlanCode ?? index}
                   plan={plan}
                   isSelected={selectedPlan?.subscriptionPlanCode === plan?.subscriptionPlanCode}
                   onSelect={(p)=>onPlanSelect(p)}
                 
                   action={(!!!activeSubscription ? PlanAction.GET:
                    activeSubscription?.subscriptionPlanCode === plan?.subscriptionPlanCode ? PlanAction.CURRENT 
                      : activeSubscription?.billingAmount < (plan?.recurringAmount??plan?.oneTimeAmount)? PlanAction.UPGRADE:PlanAction.DOWNGRADE)}
                   isLastItem={index=== (subscriptionsPlans.length-1)}
                 />
                ))
              )}
               </div>

          </div>
        <div className="flex flex-col justify-between items-center">
          {!isContinueMode && (
            <div
              onClick={() => {
              AnalyticsService.track("ASATransfer Continue Clicked", AnalyticsAction.Click, AnalyticsFeature.AsaTransfer);
              setIsContinueMode(true);
            }}
              className="dark:shadow-none shadow-[0_4px_6px_rgba(120,_120,_120,_0.7)] text-center w-full  text-white py-3 rounded-lg  font-poppins font-semibold uppercase"
              style={layout?.buttonStyle}
            >
              {t("continue")} 
            </div>
          )}

          {isContinueMode &&  !!activeSubscription  && (
           <TransferManagePlan 
           subscription={activeSubscription}   
           newPlan ={selectedPlan} 
           onCancelUpgrade={()=>setSelectedPlan(null)}
           onProceedUpgrade={()=>handleProceed(selectedPlan)}
           />
          )}

           <div className="flex justify-center items-center w-full">
           <span className="mt-3 dark:text-white  text-[#4E4E4E] text-center font-poppins text-sm font-normal leading-5 tracking-[-0.1px]"
            onClick={handleBackClick}>
            {t("return")}
           </span>
          </div>


          </div>
        </div>
      </div>
    </div>
    </div>
  );
}
